import React from 'react';
import { useNavigate } from 'react-router-dom';
import ParticlesBG from "../../Shared/ParticlesBG";
import { GeneralBox } from '../../Shared/GeneralBox';
import '../../Assets/Stylesheets/Pages/MarketingServices/Videos.scss';

// Import product data
import videoProductsData from '../../SampleData/videoProducts.json';

export default function Videos() {
  const navigate = useNavigate();

  const handleProductClick = (productId) => {
    navigate(`/product/videos/${productId}`);
  };

  // Get video services from JSON data
  const videoServices = videoProductsData.products;

  return (
    <div id="videos-page">
      <section className="videos-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">VIDEO PRODUCTION</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="videos-intro">
            <p>
              Professional video production services to elevate your brand and engage your audience.
              <span className="highlight"> Video content generates 1200% more shares than text and images combined</span>,
              driving engagement and conversions like no other medium.
            </p>
          </div>
          <h2><span className="color-font">Video Services</span></h2>
          
          {/* First row of services */}
          <div className="box-column-container">
            {videoServices.slice(0, 3).map((service) => {
              const logoSrc = require(`../../Assets/Images/${service.logo}`);
              
              return (
                <div 
                  key={service.id} 
                  className="box-column"
                  onClick={() => handleProductClick(service.id)}
                >
                  <GeneralBox
                    title={service.name}
                    link="#"
                    imageSrc={logoSrc}
                    description={service.description}
                    customContent={
                      <div className="product-price-info">
                        <div className="price">
                          {service.price > 0 ? `$${service.price}` : 'Custom Pricing'}
                        </div>
                        <button className="view-details-button" onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleProductClick(service.id);
                        }}>
                          View Details
                        </button>
                      </div>
                    }
                    className="homepage-box"
                    useGlow={true}
                  />
                </div>
              );
            })}
          </div>

          {/* Second row of services */}
          <div className="box-column-container second-row">
            {videoServices.slice(3, 6).map((service) => {
              const logoSrc = require(`../../Assets/Images/${service.logo}`);
              
              return (
                <div 
                  key={service.id} 
                  className="box-column"
                  onClick={() => handleProductClick(service.id)}
                >
                  <GeneralBox
                    title={service.name}
                    link="#"
                    imageSrc={logoSrc}
                    description={service.description}
                    customContent={
                      <div className="product-price-info">
                        <div className="price">
                          {service.price > 0 ? `$${service.price}` : 'Custom Pricing'}
                        </div>
                        <button className="view-details-button" onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleProductClick(service.id);
                        }}>
                          View Details
                        </button>
              </div>
                    }
                    className="homepage-box"
                    useGlow={true}
                  />
            </div>
              );
            })}
        </div>
      </div>
      </section>
    </div>
  );
}